import { useHistory } from 'react-router';
import { routes } from '@/constant/routes.const';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import BtnWithIcon from '@/components/MedicalReceipt/BtnWithIcon';
import FlexWrap from '@/components/common/FlexWrap';
import TextButton from '@/components/common/TextButton';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState, initialGlobalState } from '@/store';
import { isNationIncluded } from '@repo/utils';
import { MAIN_NATIONS } from '@repo/constants';

function BottomSection() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const {
    isRefundInfoRegistered,
    nationality,
    haveSeenReceipt,
    isCashPickup,
    isUploadRequired,
    departureProgress,
  } = useAppSelector((state) => state) as IGlobalState;
  const customerNationToken = localStorage.getItem('medicalCustomerNation');
  const currNation = isMobile ? customerNationToken : nationality;

  const onClickRefundInfo = () => {
    if (isRefundInfoRegistered) {
      history.push(routes.medicalRefundInfo);
    } else {
      history.push(routes.medicalCustomerRefund);
    }
  };

  const onClickReceiptInquiry = () => {
    dispatch({ type: 'UPDATE_USER_INFO', payload: { refundAfter: true } });
    history.push(routes.medicalReceipt);
  };

  const onOpenLogoutModal = () => {
    dispatch({
      type: 'UPDATE_HOME_MODAL_STATE',
      payload: {
        isActive: true,
        type: 'CUSTOM',
        data: {
          title: nationality === 'KOR' ? '로그아웃 할까요?' : 'Sign Out',
          content:
            nationality === 'KOR'
              ? '다른 여권번호로 조회하려면 로그아웃 하세요.'
              : `Sign out to look up\nanother passport number.`,
          btnText: nationality === 'KOR' ? '로그아웃' : 'Sign Out',
          subBtnText: nationality === 'KOR' ? '취소' : 'Cancel',
          btnCallback: logout,
        },
      },
    });
  };

  const logout = () => {
    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: initialGlobalState,
    });
    localStorage.clear();
    history.push(routes.medical);
  };

  return (
    <Container>
      <MainContent>
        <Title>
          {nationality === 'KOR' ? '환급절차' : 'Tax Refund Process'}
        </Title>
        <RefundProcedure dir='column'>
          <BtnWithIcon
            title={(() => {
              if (currNation === 'KOR') {
                return '송금정보 입력';
              }
              if (isCashPickup) {
                return 'Enter Personal Details';
              }
              return 'Enter information within 3 months';
            })()}
            description={(() => {
              if (currNation === 'KOR') {
                if (isRefundInfoRegistered) {
                  return '출국 확인 후 환급액 지급까지 영업일 기준 21일 정도\n소요됩니다. ';
                }
                return '환급액은 고객님 계좌로 송금됩니다. 송금에 필요한 정보를 시술 후 3개월 이내에 입력해주세요.';
              }
              if (isUploadRequired) {
                return 'The refund amount will be sent to your account. Please provide the required details within 3 months after the procedure.';
              }
              if (isCashPickup) {
                return 'Complete your information to receive your refund through Western Union';
              }
              if (isNationIncluded(MAIN_NATIONS, nationality)) {
                return "We'll send your refund to your account.\nComplete your account information.";
              }
              return 'We will send an email within 10 days to request the information needed for processing refunds. Please check your mailbox';
            })()}
            isCompleted={isRefundInfoRegistered}
            onClick={onClickRefundInfo}
            margin='0 0 28px'
          />
          {!isUploadRequired && (
            <BtnWithIcon
              title={(() => {
                if (currNation === 'KOR') {
                  return '환급전표 보기';
                }
                return 'View refund receipt';
              })()}
              description=''
              isCompleted={haveSeenReceipt}
              onClick={onClickReceiptInquiry}
              margin='0 0 28px'
            />
          )}
          {isUploadRequired && (
            <BtnWithIcon
              title='Upload Immigration Documents'
              description='Please upload documents verifying your entry or departure.'
              isCompleted={departureProgress !== 'NOT_YET_DEPARTURE'}
              onClick={() => history.push(routes.medicalUploadFile)}
              margin='0 0 28px'
            />
          )}
        </RefundProcedure>
      </MainContent>
      <BtnContainer>
        {nationality === 'KOR' && (
          <TextButton
            title='환급절차 안내'
            onClick={() => {
              history.push(routes.medicalRefundProcedure);
            }}
            color='#1856CD'
            bgColor='#fff'
            outline
            margin='0 0 12px'
          />
        )}
        <TextButton
          title={nationality === 'KOR' ? '로그아웃' : 'Log out'}
          onClick={onOpenLogoutModal}
          color='#1856CD'
          bgColor='#fff'
          outline
        />
      </BtnContainer>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  overflow-y: auto;
`;
const MainContent = styled.div`
  background-color: #ffffff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  width: 100%;
  -webkit-box-shadow: 0px 20px 20px -20px rgba(174, 191, 204, 0.5);
  box-shadow: 0px -12px 16px -2px rgba(174, 191, 204, 0.5);
  padding: 36px 20px 0;
  margin-top: 20px;
  border-bottom: 8px solid #f5f6f7;
`;
const Title = styled.h3`
  font-size: 18px;
  line-height: 150%;
  font-weight: 700;
  color: #3a3b3e;
`;
const RefundProcedure = styled(FlexWrap)`
  width: 100%;
  margin-top: 20px;
`;
const BtnContainer = styled.div`
  padding: 20px 20px 56px;
  background-color: #fff;
`;
export default BottomSection;
